import { Component, computed, inject, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { PlacementTestsService } from '../services/placement-tests.service';

const FIRST_KEYBOARD_ROW = ['w', 'e', 'r', 't', 'z', 'u', 'i', 'o', 'p', 'ü'];

const KEYBOARD_ROWS = [
  ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ö', 'ä'],
  ['y', 'x', 'c', 'v', 'b', 'n', 'm', 'ß'],
];

// Umlauts and ß are only needed for the German c-test.
const GERMAN_ONLY_CHARACTERS = ['ä', 'ö', 'ü', 'ß'];

@Component({
  selector: 'cloze-test-mobile-keyboard',
  templateUrl: './mobile-keyboard.component.html',
  styleUrls: ['./mobile-keyboard.component.scss'],
  standalone: true,
  imports: [NgStyle],
  host: {
    style: 'position: fixed; bottom: 0; left: 0; right: 0; z-index: 100;',
  },
})
export class MobileKeyboardComponent {
  readonly #placementTestsService = inject(PlacementTestsService);

  readonly lang = input('de');

  readonly firstKeyboardRow = computed(() => this.#filterRow(FIRST_KEYBOARD_ROW));
  readonly keyboardRows = computed(() => KEYBOARD_ROWS.map(row => this.#filterRow(row)));

  #filterRow(row: string[]): string[] {
    if (this.lang().toLowerCase() === 'en') {
      return row.filter(character => !GERMAN_ONLY_CHARACTERS.includes(character));
    }
    return row;
  }

  assignCharacter(character: string, event: Event): void {
    this.#placementTestsService.setSpecialCharacterToInput(character);
    event.preventDefault();
  }

  removeLastCharacter(event: Event): void {
    this.#placementTestsService.removeLastCharacterFromInput();
    event.preventDefault();
  }

  goToPreviousInput(event: Event): void {
    const inputs = this.#placementTestsService.inputs;
    if (!this.#placementTestsService.inputNumber) {
      this.#placementTestsService.inputNumber = inputs[0]?.id as number;
    } else if (this.#placementTestsService.inputNumber > 1) {
      const currentInputId = this.#placementTestsService.inputNumber;
      const idx = inputs.findIndex(i => i.id === currentInputId);
      if (inputs[idx - 1]) {
        this.#placementTestsService.inputNumber = inputs[idx - 1].id as number;
      }
    }
    event.stopPropagation();
    event.preventDefault();
  }

  goToNextInput(event: Event): void {
    const inputs = this.#placementTestsService.inputs;
    if (!this.#placementTestsService.inputNumber) {
      this.#placementTestsService.inputNumber = inputs[0]?.id as number;
    } else {
      const currentInputId = this.#placementTestsService.inputNumber;
      const idx = inputs.findIndex(i => i.id === currentInputId);
      if (inputs[idx + 1]) {
        this.#placementTestsService.inputNumber = inputs[idx + 1].id as number;
      }
    }
    event.stopPropagation();
    event.preventDefault();
  }
}
